import React, { useState } from 'react';
import { Box, ButtonBase, FormControl, FormHelperText, FormLabel, darken, makeStyles } from '@material-ui/core';
import { AddAPhoto } from '@material-ui/icons';

import { Attachment, FileInputProps } from './types';
import AttachedFile from './AttachedFile';

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: '#e9edf2',
    borderRadius: 8,
    padding: theme.spacing(3.5),

    '&:focus': {
      backgroundColor: darken('#e9edf2', 0.1),
    },
  },

  input: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    cursor: 'pointer',
  },
}));

const FileInput = ({ helperText, label, value, disabled, FormControlProps, onChange, ...props }: FileInputProps) => {
  const [files, setFiles] = useState(value);

  const classes = useStyles();

  const handleChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) return;

    if (props.multiple) {
      setFiles((prevFiles) => [...(prevFiles || []), ...Array.from(event.target.files || [])]);
      onChange?.([...(files || []), ...Array.from(event.target.files)]);
    } else {
      setFiles(Array.from(event.target.files || []));
      onChange?.(Array.from(event.target.files));
    }
  };

  const handleDeleteFile = (file: Attachment) => {
    setFiles((prevFiles) => prevFiles?.filter((prevFile) => prevFile !== file));
    onChange?.((files || [])?.filter((prevFile) => prevFile !== file));
  };

  return (
    <FormControl disabled={disabled} {...FormControlProps}>
      {label && (
        <FormLabel htmlFor="file-input" style={{ marginBottom: 8 }}>
          {label}
        </FormLabel>
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', gridGap: 8 }}>
        <ButtonBase className={classes.button} aria-label="Загрузить файл">
          <AddAPhoto />
          <input {...props} id="file-input" className={classes.input} type="file" onChange={handleChangeFile} />
        </ButtonBase>

        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gridGap: 8 }}>
          {(files || []).map((file, index) => (
            <AttachedFile file={file} key={index} disabled={disabled} onDelete={() => handleDeleteFile(file)} />
          ))}
        </Box>
      </Box>

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default FileInput;
